export default function measureNavigation() {
  if (!window.performance) return;
  if (window.performance.getEntriesByName('start navigation').length === 0) return;

  window.performance.clearMarks('finish navigation');
  window.performance.mark('finish navigation');
  window.performance.measure('frontEnd navigation', 'start navigation', 'finish navigation');
}
